const ledData = {
  rouge: { title: 'Lumière Rouge', nm: '630 nm · Anti-âge · Fermeté · Collagène', body: 'La lumière rouge pénètre dans le derme profond pour activer les fibroblastes et stimuler la synthèse de collagène et d\'élastine. Elle améliore la fermeté et réduit les rides.', tags: ['Stimule le collagène','Réduit les rides','Raffermit la peau','Améliore l\'élasticité','Peaux matures dès 30 ans'] },
  bleu: { title: 'Lumière Bleue', nm: '470 nm · Anti-acné', body: 'La lumière bleue agit sur les bactéries Cutibacterium acnes responsables des éruptions.', tags: ['Élimine les bactéries acnéiques','Régule le sébum','Purifie les pores','Réduit l\'inflammation','Prévient les nouvelles poussées'] },
  vert: { title: 'Lumière Verte', nm: '520 nm · Anti-taches', body: 'La lumière verte régule la mélanine et harmonise le teint en ciblant les zones de pigmentation irrégulière.', tags: ['Unifie le teint','Atténue les taches brunes','Efface les marques post-acné','Effet éclaircissant','Réduit les rougeurs'] },
  jaune: { title: 'Lumière Jaune', nm: '590 nm · Éclat', body: 'La lumière jaune améliore la microcirculation cutanée et favorise le drainage lymphatique.', tags: ['Stimule la microcirculation','Réduit les poches','Élimine les cernes','Oxygène les cellules','Restitue l\'éclat'] },
  violet: { title: 'Lumière Violette', nm: '415 nm · Réparation', body: 'La lumière violette combine les propriétés du rouge et du bleu pour une action synergique.', tags: ['Double action','Accélère la réparation','Améliore les cicatrices','Renouvelle l\'épiderme','Peaux abîmées'] },
  cyan: { title: 'Lumière Cyan', nm: '490 nm · Apaisement', body: 'La lumière cyan apaise les inflammations et renforce la barrière cutanée.', tags: ['Apaise les inflammations','Calme les rougeurs','Renforce la barrière','Neutralise le stress oxydatif','Peaux hypersensibles'] },
  blanc: { title: 'Lumière Blanche', nm: '400-700 nm · Profondeur', body: 'La lumière blanche combine toutes les longueurs d\'onde pour une action globale.', tags: ['Action full-spectrum','Pénétration maximale','Repulpe les volumes','Améliore la densité','Soin global'] }
};
function showLed(key) {
  const d = ledData[key];
  document.getElementById('led-detail-title').textContent = d.title;
  document.getElementById('led-detail-nm').textContent = d.nm;
  document.getElementById('led-detail-body').textContent = d.body;
  document.getElementById('led-detail-benefits').innerHTML = d.tags.map(t => `<span class="led-tag">${t}</span>`).join('');
  document.getElementById('led-detail').classList.add('active');
  document.getElementById('led-detail').scrollIntoView({ block: 'nearest' });
}
function setImg(el, src) {
  document.querySelectorAll('.buy-thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  document.getElementById('mainImg').src = src;
}

const MASK_VARIANT_ID = '57694946394499';
const MASK_PRICE = 119.70;
const VARIANT_IDS = {
  mask: '57694946394499',
  serum: '56728188256643',
  'creme-retinol': '56727788487043',
  patchs: '56728062755203',
  'stick-yeux': '56728299307395'
};

function navWithPreview(path) {
  try {
    const u = new URL(path, window.location.origin);
    const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) u.searchParams.set('preview_theme_id', previewId);
    window.location.href = u.toString();
  } catch(e) { window.location.href = path; }
}

window.applyDiscount = function(e, form) {
  e.preventDefault();
  const code = form.code.value.trim();
  if (!code) return;
  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  let url = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  if (previewId) url += '&preview_theme_id=' + previewId;
  window.location.href = url;
};

function addToCart() {
  startCartUrgency();
  openUpsell();
  try {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: MASK_VARIANT_ID, quantity: 1}]})
    }).then(() => fetch('/cart.js'))
      .then(r => r.json())
      .then(c => {
        document.querySelectorAll('.cart-bubble').forEach(b => { b.textContent = c.item_count; });
      }).catch(() => {});
  } catch(e) {}
}

function openUpsell() {
  const m = document.getElementById('upsellOverlay');
  if (!m) return;
  m.setAttribute('style', 'display:flex !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;width:100% !important;height:100% !important;z-index:999999 !important;align-items:center !important;justify-content:center !important;background:rgba(26,20,16,0.6) !important;opacity:1 !important;visibility:visible !important;pointer-events:auto !important;transform:none !important;');
  m.classList.add('show');
  if (m.parentElement !== document.body) {
    document.body.appendChild(m);
  }
  try { recalcUpsell(); } catch(e) {}
}

function closeUpsell() {
  const m = document.getElementById('upsellOverlay');
  if (!m) return;
  m.classList.remove('show');
  m.style.cssText = 'display:none !important;';
  document.body.classList.remove('modal-open');
}

function toggleUpsell(el) {
  if (el.dataset.syncing === '1') return;
  el.classList.toggle('added');
  const isAdded = el.classList.contains('added');
  const txtSpan = el.querySelector('.upsell-toggle-text');
  if (isAdded) txtSpan.innerHTML = '✓ Ajouté';
  else txtSpan.textContent = '+ Ajouter';
  recalcUpsell();
  const variantId = VARIANT_IDS[el.dataset.product];
  if (!variantId) return;
  el.dataset.syncing = '1';
  const refresh = function() {
    return fetch('/cart.js').then(r => r.json()).then(c => {
      document.querySelectorAll('.cart-bubble').forEach(b => { b.textContent = c.item_count; });
    }).catch(() => {});
  };
  const req = isAdded
    ? fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body: JSON.stringify({items:[{id: variantId, quantity: 1}]})})
    : fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body: JSON.stringify({id: String(variantId), quantity: 0})});
  req.then(refresh).catch(() => {}).then(() => { el.dataset.syncing = '0'; });
}

function recalcUpsell() {
  let total = MASK_PRICE;
  let count = 1;
  document.querySelectorAll('.upsell-product.added').forEach(el => {
    total += parseFloat(el.dataset.price) || 0;
    count++;
  });
  const totalEl = document.getElementById('upsellTotal');
  const countEl = document.getElementById('upsellItemCount');
  if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
  if (countEl) countEl.textContent = count + (count > 1 ? ' articles' : ' article');
  const btn = document.getElementById('upsellCheckoutBtn');
  if (btn && btn.firstChild) {
    btn.firstChild.textContent = count > 1
      ? 'Continuer vers le paiement (' + count + ' articles)'
      : 'Continuer vers le paiement';
  }
}

async function goToCheckout(e) {
  e.preventDefault();
  const items = [{id: VARIANT_IDS.mask, quantity: 1}];
  document.querySelectorAll('.upsell-product.added').forEach(el => {
    const key = el.dataset.product;
    if (VARIANT_IDS[key]) items.push({id: VARIANT_IDS[key], quantity: 1});
  });
  try {
    await fetch('/cart/clear.js', {method:'POST'});
    await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body: JSON.stringify({items: items})});
  } catch(err) {}
  navWithPreview('/checkout');
}

document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeUpsell(); });

function wireNavButtons() {
  document.querySelectorAll('.nav-icon[title="Recherche"]').forEach(btn => { btn.style.display = 'none'; });
  document.querySelectorAll('.nav-icon[title="Panier"]').forEach(btn => {
    btn.onclick = function(e) { if(e) e.preventDefault(); navWithPreview('/cart'); };
  });
  document.querySelectorAll('.nav-buy').forEach(btn => {
    btn.onclick = function(e) { e.preventDefault(); addToCart(); return false; };
  });
  fetch('/cart.js').then(r => r.json()).then(c => {
    document.querySelectorAll('.cart-bubble').forEach(b => { b.textContent = c.item_count; });
  }).catch(() => {});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireNavButtons);
else wireNavButtons();

let cartTimerInt = null;
let cartSecondsLeft = 15 * 60;
function startCartUrgency() {
  const m = document.getElementById('cartUrgency');
  if (!m) return;
  m.classList.add('show');
  if (cartTimerInt) return;
  cartSecondsLeft = 15 * 60;
  const timerEl = document.getElementById('cartTimer');
  function tick() {
    if (cartSecondsLeft <= 0) { clearInterval(cartTimerInt); cartTimerInt = null; if (timerEl) timerEl.textContent = 'Expiré'; return; }
    const mm = Math.floor(cartSecondsLeft / 60);
    const ss = cartSecondsLeft % 60;
    if (timerEl) timerEl.textContent = mm + ':' + (ss < 10 ? '0' : '') + ss;
    cartSecondsLeft--;
  }
  tick();
  cartTimerInt = setInterval(tick, 1000);
}

function toggleFaq(el) { el.parentElement.classList.toggle('open'); }

const obs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
}, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
document.querySelectorAll('[data-reveal]').forEach(el => obs.observe(el));

setInterval(() => {
  const v = document.getElementById('viewersNum');
  if (v) {
    const cur = parseInt(v.textContent, 10);
    v.textContent = Math.max(15, Math.min(38, cur + Math.floor(Math.random() * 5) - 2));
  }
}, 4000);

/* === PRODUCT PAGES: variant selection + add to cart === */
function selectProductVariant(input, btnId, priceId, groupName) {
  document.querySelectorAll('input[name="' + groupName + '"]').forEach(inp => {
    inp.closest('.product-variant').classList.toggle('is-selected', inp.checked);
  });
  const btn = document.getElementById(btnId);
  const priceEl = document.getElementById(priceId);
  if (btn) {
    btn.dataset.variant = input.value;
    btn.dataset.price = input.dataset.price;
    const txtSpan = btn.querySelector('.product-add-text');
    if (txtSpan) txtSpan.textContent = 'Ajouter au panier — ' + input.dataset.price + ' €';
  }
  if (priceEl) priceEl.textContent = input.dataset.price + ' €';
}

function addProductToCart(btn) {
  const variantId = btn.dataset.variant;
  const price = btn.dataset.price;
  if (!variantId) return;
  const txtSpan = btn.querySelector('.product-add-text');
  const originalText = 'Ajouter au panier — ' + price + ' €';
  btn.classList.add('added');
  if (txtSpan) txtSpan.textContent = '✓ Ajouté au panier';
  startCartUrgency();
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({items:[{id: variantId, quantity:1}]})
  }).then(() => fetch('/cart.js')).then(r => r.json()).then(c => {
    document.querySelectorAll('.cart-bubble').forEach(b => { b.textContent = c.item_count; });
  }).catch(() => {});
  setTimeout(() => {
    btn.classList.remove('added');
    if (txtSpan) txtSpan.textContent = originalText;
  }, 2500);
}

function showPage() {
  const hash = (window.location.hash || '').replace('#','');
  const homeAnchors = ['produit','science','results','avis','faq','avant-apres'];
  const pages = ['contact','livraison','remboursement','cgv','cgu','mentions','confidentialite','soins','p-serum','p-creme-retinol','p-stick-lifting','p-patchs','p-stick-yeux','p-masque-bio','p-masque-nuit','p-soin-levres'];
  const target = pages.includes(hash) ? hash : 'home';
  document.querySelectorAll('.page').forEach(p => { p.classList.toggle('active', p.dataset.page === target); });
  if (target === 'home' && homeAnchors.includes(hash)) {
    setTimeout(() => { const el = document.getElementById(hash); if (el) el.scrollIntoView({behavior:'smooth', block:'start'}); }, 60);
  } else { window.scrollTo(0, 0); }
}
window.addEventListener('hashchange', showPage);
showPage();
